import { ISMBase } from '../ism-base';
export class Haymaket_NPI extends ISMBase {
    constructor() {
        super(...arguments);
        /**
         * provider : Haymaket_NPI
         */
        this.identityServiceProvider = 'Haymaket_NPI';
        this.priorityOrder = 1;
    }
    fetchIdentityServiceProviderPromise() {
        return new Promise((resolve) => {
            try {
                setTimeout(() => {
                    let npiCookie = window.Cookies && window.Cookies.get('hmNpiId');
                    let npiFromURL = window.hmUtils && window.hmUtils.getParameterByName('NID');
                    let adnidCookie = window.Cookies && window.Cookies.get('adnid'); //hashed npi
                    let npi = {};
                    if (npiCookie) {
                        npi['value'] = npiCookie;
                        npi['key'] = 'NPI Cookie';
                    }
                    else if (adnidCookie) {
                        npi['value'] = adnidCookie;
                        npi['key'] = 'adnid Cookie';
                    }
                    else if (npiFromURL) {
                        npi['value'] = npiFromURL;
                        npi['key'] = 'NID query parameter';
                    }
                    this.controller.resolvedServicesData.push({ 'identityServiceProvider': this.identityServiceProvider, value: npi });
                    this.controller.dataStack.push({ 'identityServiceProvider': this.identityServiceProvider, value: npi });
                    if (Object.keys(npi).length) {
                        this.setIdentityServiceProviderTargeting({ 'identityServiceProvider': this.identityServiceProvider, 'value': npi['value'] });
                        resolve({ 'identityServiceProvider': this.identityServiceProvider, 'responseText': `${this.identityServiceProvider} Data was sent to GAM from the ${npi['key']}`, value: npi['value'] });
                    }
                    else {
                        resolve({ 'identityServiceProvider': this.identityServiceProvider, 'responseText': `${this.identityServiceProvider} NPI not found! : ${this.identityServiceProvider} targeting skipped` });
                    }
                }, this.controller.timeout);
            }
            catch (error) {
                resolve(this.getErrorMessage(error));
            }
        });
    }
    setIdentityServiceProviderTargeting(identityServiceProviderData) {
        let providerData = identityServiceProviderData;
        const npiNumber = providerData && providerData['value'];
        let existingData = this.controller.gamTargetingData.findIndex((value) => {
            return value.priorityOrder === this.priorityOrder;
        });
        let targetingData = {};
        if (npiNumber) {
            targetingData['npi'] = npiNumber.length > 10 ? '' : npiNumber;
        }
        if (existingData > -1) {
            Object.keys(targetingData).length && Object.assign(this.controller.gamTargetingData[existingData].targetingData, targetingData);
        }
        else {
            let providerTargetingData = { 'priorityOrder': this.priorityOrder, 'targetingData': targetingData };
            this.controller.gamTargetingData.push(providerTargetingData);
        }
    }
}
